import { render } from "./Product_History.vue?vue&type=template&id=d534f638"
import script from "./Product_History.vue?vue&type=script&lang=js"
export * from "./Product_History.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__